require('@babel/polyfill');
require('promise-polyfill/src/polyfill');
require('whatwg-fetch');
require('url-search-params-polyfill');
require('intl');
require('intl/locale-data/jsonp/en');
